<template>
  <div>
    <h5 class="ts-capitalize">
      {{
        shop.customer_code +
          '-' +
          shop.customer_name +
          ',' +
          shop.commune_name_en +
          ' Commune, ' +
          shop.district_name_en +
          ' District, ' +
          shop.province_name_en +
          ' Province'
      }}
    </h5>
    <div class="row">
      <div class="col-md-4">
        <!-- src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkq96a4bkVzlgF-FiQdyx7KOPb-kk71ONjXteyLZWHUUVrwrkT8xxuXAR2uHYUt5YZ33o&usqp=CAU" -->
        <img
          :src="shop.front_photo1"
          @error="onImagError"
          class="ts-w-full ts-object-contain ts-object-center"
          alt=""
          style="height: 400px"
        />
      </div>
      <div class="col-md-8">
        <gmap-map
          :center="center"
          :zoom="13"
          style="width:100%;  height: 100%;"
        >
				  	<gmap-polyline
							:path="polyLin"
							:options="{ geodesic: true, strokeColor: '#FF0000' }"
						>
						</gmap-polyline>
          <gmap-marker
            v-for="(position, index) in allMakers"
						:draggable="true"
            :key="index"
            :position="position.marker"
          >
            <!-- :icon="{
              url:
                (position.customer_id + position.check_in_time) == (shop.customer_id + shop.check_in_time)
                  ? marker
                  : marker_opac
            }" -->
          </gmap-marker>
        </gmap-map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'viewShopMap',
  props: ['record', 'shop'],
  data() {
    return {
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      // marker: require('@/assets/marker.png'),
      // marker_opac: require('@/assets/marker_opa.png')
    }
  },
  created() {
    if (this.shop) {
      this.center = { lng: this.shop.dealer_long, lat: this.shop.dealer_lat }
    }
  },
  computed: {
		polyLin(){
      if (this.record.json_visitation_detail) {
        return this.record.json_visitation_detail.filter(d => d.check_in_time != null).map(el => ({
            lat: el.dealer_lat,
            lng: el.dealer_long
        }))
      }
      return []
		},
    allMakers() {
      if (this.record.json_visitation_detail) {
        return this.record.json_visitation_detail.map(el => ({
          customer_id: el.customer_id,
          check_in_time: el.check_in_time,
          marker: {
            lat: el.dealer_lat,
            lng: el.dealer_long
          }
        }))
      }
      return []
    }
  },
  methods: {
    onImagError(e) {
      e.target.src =
        'http://dslv9ilpbe7p1.cloudfront.net/wQ1sJi1CCJpI87JfbO8nrA_store_header_image'
    }
  }
}
</script>
